import { Game } from '../../../interfaces/Games.interface';

type UseCompetitionsFromSelectedTeamsProps = {
  teams: string[];
  allGames: Game[];
  selectedCompetitions?: string[];
};

const useCompetitionsFromSelectedTeams = ({
  teams,
  allGames,
  selectedCompetitions,
}: UseCompetitionsFromSelectedTeamsProps): string[] => {
  const competitions = new Set<string>();
  const selectedTeamsSet = new Set(teams);
  for (let i = 0; i < allGames.length; i++) {
    const game = allGames[i];
    if (
      selectedTeamsSet.has(game.team_home) ||
      selectedTeamsSet.has(game.team_away)
    ) {
      competitions.add(game.tournament_name);
    }
  }

  selectedCompetitions?.forEach((competition) => {
    competitions.add(competition);
  });

  return Array.from(competitions);
};

export default useCompetitionsFromSelectedTeams;
